export default {
	UPDATE_CONVERSATION_TRAIL(state, val) {
		state.conversationTrail = val
	},
	UPDATE_PROMPT(state, val) {
		state.prompt = val
	},  	
}

